// extracted by mini-css-extract-plugin
export default {"clearButton":"ClearButton_clearButton__npUXU"};